const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getTemplates(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.reportTypeId) params.append('reportTypeId', filters.reportTypeId);
  if (filters.format) params.append('format', filters.format);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/templates${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch templates');
  }
  
  const data = await response.json();
  return data.templates;
}

export async function getTemplate(orgId, templateId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/templates/${templateId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Template not found');
    }
    throw new Error('Failed to fetch template');
  }
  
  const data = await response.json();
  return data.template;
}

export async function getTemplateVersions(orgId, templateId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/templates/${templateId}/versions`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch template versions');
  }
  
  const data = await response.json();
  return data.versions;
}

export async function createTemplate(orgId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/templates`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to create templates');
    }
    throw new Error('Failed to create template');
  }
  
  return response.json();
}

export async function updateTemplate(orgId, templateId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/templates/${templateId}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to update templates');
    }
    if (response.status === 404) {
      throw new Error('Template not found');
    }
    throw new Error('Failed to update template');
  }
  
  return response.json();
}
